import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regenerator as _regenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback, useEffect } from 'react';
import { SSOButton } from '../SSOButton.js';
import { Button } from '../Button/index.js';
import { i18n } from '../../i18n/translate.js';
import { sanitizeUrl } from '@braintree/sanitize-url';
import googleLogoImg from '../../images/google_logo.svg.js';
import facebookLogoImg from '../../images/facebook_logo.svg.js';
import { Flex, Divider, Text } from '@chakra-ui/react';
var LoginBox = function LoginBox(_ref) {
  var authCaps = _ref.authCaps,
    authUrls = _ref.authUrls,
    idProvidersUrl = _ref.idProvidersUrl,
    _ref$loginText = _ref.loginText,
    loginText = _ref$loginText === void 0 ? i18n.t('Login to save your progress') : _ref$loginText,
    onLoginLoad = _ref.onLoginLoad,
    socialIcon = _ref.socialIcon;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    samlIdProviders = _useState2[0],
    setSamlIdProviders = _useState2[1];
  var loadSamlIdProviders = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee() {
    var idProviders;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!idProvidersUrl) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return fetch(idProvidersUrl).then(function (res) {
            return res.json();
          });
        case 1:
          idProviders = _context.v;
          setSamlIdProviders(idProviders);
        case 2:
          return _context.a(2);
      }
    }, _callee);
  })), [idProvidersUrl]);
  useEffect(function () {
    if (onLoginLoad) onLoginLoad();
    loadSamlIdProviders();
  }, [loadSamlIdProviders, onLoginLoad]);
  var constructUrl = function constructUrl(authType) {
    return authUrls ? (authUrls.find(function (entry) {
      return entry.auth_type === authType;
    }) || authUrls[0]).url : '';
  };
  var socialLogin = function socialLogin() {
    if (!(authCaps !== null && authCaps !== void 0 && authCaps.facebook) && !(authCaps !== null && authCaps !== void 0 && authCaps.google)) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, authCaps.google && /*#__PURE__*/
    /* Remove when below is TypeScript-ified */
    /* @ts-ignore */
    React.createElement(SSOButton, {
      branded: true,
      href: constructUrl('google'),
      label: i18n.t('Continue with Google'),
      imgUrl: googleLogoImg,
      data: {
        action: 'login-with-google'
      }
    }), authCaps.facebook && /*#__PURE__*/
    /* Remove when below is TypeScript-ified */
    /* @ts-ignore */
    React.createElement(SSOButton, {
      branded: true,
      href: constructUrl('facebook'),
      label: i18n.t('Continue with Facebook'),
      imgUrl: facebookLogoImg,
      icon: "facebook",
      iconFamily: "fa",
      data: {
        action: 'login-with-facebook'
      }
    }));
  };
  var emailLogin = function emailLogin() {
    if (!(authCaps !== null && authCaps !== void 0 && authCaps.email)) return null;
    return /*#__PURE__*/React.createElement(Button
    /* @ts-ignore */, {
      href: constructUrl('email_login'),
      style: "primary",
      label: i18n.t('Continue with Email or Username'),
      branded: true,
      data: {
        action: 'login-with-email-or-username'
      },
      className: "w-100"
    });
  };
  var usernameLogin = function usernameLogin() {
    if (!(authCaps !== null && authCaps !== void 0 && authCaps.username)) return null;
    return /*#__PURE__*/React.createElement(Button
    /* @ts-ignore */, {
      href: constructUrl('username'),
      style: "primary",
      label: i18n.t('Continue with Username'),
      branded: true,
      block: true,
      className: "large w-100",
      data: {
        action: 'login-with-username'
      }
    });
  };
  var canShowSaml = function canShowSaml() {
    return (authCaps === null || authCaps === void 0 ? void 0 : authCaps.saml) && samlIdProviders.length > 0;
  };
  var samlLogin = function samlLogin() {
    if (!canShowSaml()) return null;
    return samlIdProviders.map(function (provider) {
      var label = i18n.t('Log In with %s Account', {
        postProcess: 'sprintf',
        sprintf: [provider.display_name]
      });
      var authUrl = provider.auth_url.replace('relay_state_value', encodeURIComponent(window.location.href));
      return /*#__PURE__*/(
        // @ts-ignore
        React.createElement(SSOButton, {
          data: {
            action: 'login-with-sso'
          },
          branded: true,
          key: provider.id,
          href: sanitizeUrl(authUrl),
          label: label,
          imgUrl: socialIcon
        })
      );
    });
  };
  var conditionalOrTag = function conditionalOrTag() {
    // only display 'or' heading tag when one of the default auth capabilites are active if saml cap active
    if (!(authCaps !== null && authCaps !== void 0 && authCaps.email) || !(authCaps !== null && authCaps !== void 0 && authCaps.google || authCaps !== null && authCaps !== void 0 && authCaps.facebook) && !canShowSaml()) return null;
    return /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center",
      justifyContent: "center"
    }, /*#__PURE__*/React.createElement(Divider, {
      orientation: "horizontal",
      borderColor: "gray.300"
    }), /*#__PURE__*/React.createElement(Text, {
      mx: 2
    }, "or"), /*#__PURE__*/React.createElement(Divider, {
      orientation: "horizontal",
      borderColor: "gray.300"
    }));
  };
  var showSsoLogin = (authCaps === null || authCaps === void 0 ? void 0 : authCaps.facebook) || (authCaps === null || authCaps === void 0 ? void 0 : authCaps.google) || canShowSaml();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "login-title text-center m-b-30"
  }, /*#__PURE__*/React.createElement("h2", {
    tabIndex: "-1"
  }, i18n.t('Log In')), /*#__PURE__*/React.createElement("h4", {
    className: "text-muted"
  }, loginText)), showSsoLogin && /*#__PURE__*/React.createElement("div", {
    className: "sso-login"
  }, socialLogin(), samlLogin()), conditionalOrTag(), emailLogin(), usernameLogin(), ((authCaps === null || authCaps === void 0 ? void 0 : authCaps.email) || (authCaps === null || authCaps === void 0 ? void 0 : authCaps.username)) && /*#__PURE__*/React.createElement("div", {
    className: "register-text text-center m-t-20"
  }, i18n.t("Don't have an account?"), /*#__PURE__*/React.createElement("a", {
    className: "branded-link m-l-5",
    href: constructUrl('email_registration')
  }, i18n.t('Register'))));
};
export { LoginBox as default };